var template = {
  
  contractNumber: function (contractOptions) {
    return contractOptions.contractNumber.length > 0 
      ? ' (nr umowy: ' + contractOptions.contractNumber + ')'
      : ''
  },

  // Methods that you need, for e.g fetching data from server etc.
  terminationTime: function (contractOptions) {
    var result;
    switch (parseInt(contractOptions.terminationTime)) {
      case 2:
        result = '3 miesiące';
        break;
      case 3:
        result = contractOptions.customTerminationTime;
        break;
      default:
        result = '1 miesiąc';
    }

    return result;
  },
  prepareContent: function (contractOptions, employee, employer) {
    var docDefinition = {
      content: [

        {
          fontSize: 10,
          alignment: 'right',
          columns: [
            {
              text: contractOptions.city + ', ' + contractOptions.terminationDate.toLocaleDateString()
            }
          ]
        },
        {
          alignment: 'left',
          fontSize: 10,
          columns: [
            {
              text: '\n\n' + employee.companyName + '\nNIP: ' + employee.nip + '\nAdres: ' + employee.address + '\n' + employee.postalCode + ' ' + employee.city
            }
          ]
        },
        {
          alignment: 'left',
          fontSize: 10,

          columns: [
            {
              text: '',
            },  
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '\n' + employer.name + '\nNIP: ' + employer.nip + '\n Adres: ' + employer.address + '\n' + employer.postalCode + ' ' + employer.city
            }
          ]
        },
        {
          alignment: 'center',
          fontSize: 20,
          columns: [
            {
              text: '\n\n\n\nWYPOWIEDZENIE UMOWY'
            }
          ]
        },
        {
          alignment: 'justify',
          fontSize: 11,
          columns: [
            {
              text: '\nJa niżej podpisany ' + employee.name + ', działając w imieniu ' + employee.companyName + ' wypowiadam umowę o świadczenie usług' + this.contractNumber(contractOptions) +' zawartą dnia ' + contractOptions.contractDate.toLocaleDateString() + ' pomiędzy ' + employer.name + ' a ' + employee.companyName + '. Zgodnie z postanowieniami umowy okres wypowiedzenia wynosi ' + this.terminationTime(contractOptions) + '.'
            }
          ]
        },

        {
          alignment: 'left',
          fontSize: 12,

          columns: [
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '',
            },
            {
              text: '\n\n\nZ poważaniem\n\n    ..........................'
            }
          ]
        },
        {
          alignment: 'left',
          fontSize: 12,

          columns: [
            {
              text: '\n\n\nPotwierdzam otrzymanie wypowiedzenia\n\n......................................................................'
            }
          ]
        },


      ],
      defaultStyle: {
        columnGap: 15
      }
    };

    return docDefinition;
  }



};

export default template